(() => {
  const script = document.getElementById('bf-seo-internal-links');
  if (!script) return;

  const sourceUrl = new URL(script.dataset.sourceUrl || '', window.location.origin);
  const targetUrl = new URL(script.dataset.targetUrl || '', window.location.origin);
  const isCustomProduct = script.dataset.customProduct === 'true';
  const normalizePath = (path) => path.replace(/\/+$/, '') || '/';
  const sourcePath = normalizePath(sourceUrl.pathname);

  const rewriteElement = (element) => {
    const attribute = element.matches('a[href]') ? 'href' : 'data-url';
    const value = element.getAttribute(attribute);
    if (!value) return;

    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin || normalizePath(url.pathname) !== sourcePath) return;

    url.pathname = targetUrl.pathname;
    element.setAttribute(attribute, `${url.pathname}${url.search}${url.hash}`);
  };

  const rewriteTree = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.matches?.('a[href], [data-url]')) rewriteElement(root);
    root.querySelectorAll?.('a[href], [data-url]').forEach(rewriteElement);
  };

  const cleanupCustomProductSeo = (root) => {
    if (!isCustomProduct) return;
    const selector = [
      '#tinyimg-product-json-ld',
      'meta[property="product:availability"]',
      'meta[property="product:price:amount"]',
      'meta[property="product:price:currency"]',
    ].join(', ');

    if (root.matches?.(selector)) root.remove();
    root.querySelectorAll?.(selector).forEach((element) => element.remove());
  };

  rewriteTree(document);
  cleanupCustomProductSeo(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(rewriteTree);
      mutation.addedNodes.forEach(cleanupCustomProductSeo);
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
